import type { BadgeTone } from '@/components/ui/badge';
import { toolStateTone } from '@/lib/toolStateTone';

/**
 * Tone of a tool's final state on the dashboard: the shared tool-state colours
 * (`lib/toolStateTone`: new = success, worn = warning, broken = error), any `broken*`
 * variant counting as broken, `unknown` neutral (as on every other screen), and the other
 * in-service states (active…) in primary.
 */
export function finalStateTone(state: string): BadgeTone {
  if (state === 'unknown') return 'neutral';
  const tone = toolStateTone(state.startsWith('broken') ? 'broken' : state);
  return tone === 'neutral' ? 'primary' : tone;
}

/** CSS colour of a tone, for chart marks (SVG fills), light and dark. */
export const TONE_COLOR: Record<BadgeTone, string> = {
  neutral: 'var(--muted-foreground)',
  primary: 'var(--primary)',
  success: 'var(--success)',
  warning: 'var(--warning)',
  error: 'var(--destructive)',
  info: 'var(--info)',
};

/** Background class of a tone, for HTML bars. */
export const TONE_BG: Record<BadgeTone, string> = {
  neutral: 'bg-muted-foreground',
  primary: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-destructive',
  info: 'bg-info',
};
